import { CheckStyleKinds, Color, OptionalFeature, ColorSpecifiedFeature } from "../../../../base/domain/drawing";
import { ICheckStyle } from "./ICheckStyle";

export class CheckStyle {
  constructor(
    public kind: CheckStyleKinds        = CheckStyleKinds.Check,
    public paint: ColorSpecifiedFeature = new ColorSpecifiedFeature(false, new Color("#ffffff")),
    public border: OptionalFeature      = new OptionalFeature(true),
  ) {
  }

  clone(): CheckStyle {
    return new CheckStyle(this.kind, this.paint.clone(), this.border.clone());
  }

  static from(source: ICheckStyle): CheckStyle {
    return new CheckStyle(source.kind, ColorSpecifiedFeature.from(source.paint), OptionalFeature.from(source.border));
  }

  static to(source: CheckStyle): ICheckStyle {
    return {
      kind: source.kind,
      paint: ColorSpecifiedFeature.to(source.paint),
      border: OptionalFeature.to(source.border),
    };
  }
}
